import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useHistory } from "react-router-dom";
// Limitless Imports
import { useCustomerContext, useCustomerMessageContext } from "@limitless/customer/hooks";
import { SubmitButton } from "@limitless/customer/components";
import { ClientContext } from "@limitless/common/utils";
import NewQuestionTextInput from "../new-question-text-input/NewQuestionTextInput";
import ClientSecureEmailLabel from "../client-secure-email-label/ClientSecureEmailLabel";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginTop: 24,
        marginLeft: 16,
        marginRight: 16
    },
    inputContainer: {
        marginBottom: 8
    }
});

const CreateNewMessageForm = () => {
    const { customer, getCustomerData, updateCustomer } = useCustomerContext();
    const { question, isFormInvalid, fieldErrors } = customer;
    const classes = useStyles();
    const { message, createMessage } = useCustomerMessageContext();
    const history = useHistory();

    const handleSubmit = () => {
        createMessage(getCustomerData(), newMessage => {
            history.push(`/conversation/${newMessage.messageId}/${newMessage.accessKey}/${false}`);
        });
    };

    const handleQuestionChange = event => {
        updateCustomer("question", event.target.value);
    };

    const allOrEmailCaptureSupress =
        ClientContext._userCaptureSuppress === "all" || ClientContext._userCaptureSuppress === "email";

    return (
        <div className={classes.container}>
            <NewQuestionTextInput
                label="Question"
                error={fieldErrors.question ? true : false}
                helperText={fieldErrors.question}
                onChange={handleQuestionChange}
                value={question.value}
                rows={4}
                multiline
                fullWidth
                containerClass={classes.inputContainer}
                disabled={message.loading}
                id="newQuestionInput"
            />
            {allOrEmailCaptureSupress && <ClientSecureEmailLabel />}
            <div style={{ alignSelf: "center" }}>
                <SubmitButton
                    disabled={message.loading || isFormInvalid}
                    title="Submit Your Question"
                    handleSubmit={handleSubmit}
                    loading={message.loading}
                    containerEnabled={false}
                />
            </div>
        </div>
    );
};

export default CreateNewMessageForm;
